"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const react_1 = tslib_1.__importDefault(require("react"));
const react_components_1 = require("@apollo/react-components");
const react_hanger_1 = require("react-hanger");
const react_moment_1 = tslib_1.__importDefault(require("react-moment"));
const react_router_dom_1 = require("react-router-dom");
const react_use_1 = require("react-use");
const reactstrap_1 = require("reactstrap");
const reusables_1 = require("../../../../comps/reusables");
const CheckIcon_1 = require("../../../../comps/reusables/CheckIcon");
const graphql_1 = require("../../../../graphql");
const ResourceList_1 = require("../ResourceList");
const ResourceListTable_1 = require("../ResourceListTable");
const ResourceSelector_1 = require("./ResourceSelector");
const react_2 = require("@osmosys/react");
const AddUserToWorkspaceMembershipModal = react_router_dom_1.withRouter(({ isOpen, onClose, history }) => {
    const input = react_hanger_1.useInput('');
    const [newWorkspaceId, setWorkspaceId] = react_1.default.useState(null);
    const { setState, state } = react_hanger_1.useSetState({
        user: null,
        workspace: null,
    });
    // Redirect when mutation was successful
    react_1.default.useEffect(() => {
        let t;
        if (!isNaN(newWorkspaceId) && newWorkspaceId !== null) {
            t = setTimeout(() => {
                history.push(`/admin/memberships/${newWorkspaceId}`);
            }, 2 * 1000);
        }
        return () => {
            clearTimeout(t);
        };
    }, [history, newWorkspaceId]);
    return (react_1.default.createElement(react_components_1.Mutation, { mutation: graphql_1.createWorkspace, variables: {
            data: {
                name: input.value,
            },
        }, onCompleted: ({ createWorkspace }) => {
            setWorkspaceId(createWorkspace.id);
        } }, (save, mutationResult) => {
        const disabled = !!(newWorkspaceId || mutationResult.loading);
        return (react_1.default.createElement(react_2.OsmosysModal, { osysName: "WorkspaceMembershipsList", osysSubType: "Create", isOpen: isOpen, centered: true, toggle: () => onClose() },
            react_1.default.createElement(reactstrap_1.ModalHeader, { toggle: () => onClose() }, newWorkspaceId
                ? 'Redirecting...'
                : 'Add new workspace membership'),
            react_1.default.createElement(reactstrap_1.ModalBody, null,
                react_1.default.createElement(ResourceSelector_1.ResourceSelector, { resource: "user", value: state.user, onChange: user => {
                        setState({
                            user,
                        });
                    } }),
                react_1.default.createElement(ResourceSelector_1.ResourceSelector, { value: state.workspace, onChange: workspace => {
                        setState({
                            workspace,
                        });
                    }, resource: "workspace" }),
                react_1.default.createElement(reusables_1.AjaxButton, { label: newWorkspaceId ? 'Redirecting...' : 'Add user to workspace', onClick: () => {
                        save();
                    }, color: "success", error: mutationResult.error, success: !!mutationResult.data, loading: mutationResult.loading, disabled: disabled }),
                react_1.default.createElement(react_2.OsmosysErrorAlert, { apolloError: mutationResult.error, resource: "Workspace", action: "create" }))));
    }));
});
exports.WorkspaceMembershipsList = () => {
    const [showAddWorkspaceMembershipModal, toggleAddWorkspaceMembershipModal,] = react_use_1.useToggle(false);
    return (react_1.default.createElement(ResourceListTable_1.ResourceListTable, { variables: () => {
            return {};
        }, cells: wsm => {
            return [
                react_1.default.createElement("span", { className: classnames_1.default('font-weight-bold'), key: 1 },
                    react_1.default.createElement(react_router_dom_1.Link, { className: "text-reset", to: `/admin/memberships/${wsm.user.id}` }, wsm.id)),
                react_1.default.createElement("span", { key: 2, className: classnames_1.default('font-weight-bold', !wsm.user.fullName && 'text-muted') },
                    react_1.default.createElement(react_router_dom_1.Link, { className: "text-reset", to: `/admin/users/${wsm.user.id}` }, wsm.user.fullName || `Membership #${wsm.id}`)),
                react_1.default.createElement("span", { key: 3, className: classnames_1.default('font-weight-bold', !wsm.workspace.name && 'text-muted') },
                    react_1.default.createElement(react_router_dom_1.Link, { className: "text-reset", to: `/admin/workspaces/${wsm.workspace.id}` }, wsm.workspace.name || `Workspace #${wsm.workspace.id}`)),
                react_1.default.createElement(react_moment_1.default, { key: 4, format: "lll", className: "font-weight-light" }, wsm.createdAt),
                react_1.default.createElement(react_moment_1.default, { key: 5, format: "lll", className: "font-weight-light" }, wsm.updatedAt),
                react_1.default.createElement(CheckIcon_1.CheckIcon, { key: 6, checked: wsm.isActive }),
                react_1.default.createElement(CheckIcon_1.CheckIcon, { key: 7, checked: wsm.isWorkspaceAdmin }),
            ];
        }, filters: react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ResourceList_1.ResourceList.Filter, { name: "searchQuery", defaultValue: "", options: [
                    {
                        label: 'All memberships',
                        value: 'all',
                    },
                    {
                        label: 'Show just my memberships',
                        value: 'me',
                    },
                ] }),
            react_1.default.createElement(ResourceList_1.ResourceList.Filter, { name: "isActive", defaultValue: "showActive", options: [
                    {
                        label: 'Show active memberships',
                        value: 'showActive',
                    },
                    {
                        label: 'Hide active memberships',
                        value: 'hideActive',
                    },
                    {
                        label: 'Show active and inactive memberships',
                        value: 'all',
                    },
                ] }),
            react_1.default.createElement(ResourceList_1.ResourceList.Filter, { name: "deleted", defaultValue: "hideDeleted", options: [
                    {
                        label: 'Hide deleted users',
                        value: 'hideDeleted',
                    },
                    {
                        label: 'Show deleted users',
                        value: 'showDeleted',
                    },
                    {
                        label: 'Show deleted and non-deleted users',
                        value: 'all',
                    },
                ] }),
            react_1.default.createElement(reactstrap_1.Button, { color: "success", size: "sm", className: "ml-2", onClick: () => {
                    toggleAddWorkspaceMembershipModal();
                }, disabled: true }, "Add user to workspace"),
            react_1.default.createElement(AddUserToWorkspaceMembershipModal, { isOpen: showAddWorkspaceMembershipModal, onClose: () => {
                    toggleAddWorkspaceMembershipModal(false);
                } })), headers: [
            {
                direction: 'ASC',
                label: 'ID',
                name: 'id',
                width: 5,
            },
            {
                direction: 'ASC',
                label: 'Name',
                name: 'name',
                width: 20,
            },
            {
                direction: 'ASC',
                label: 'Workspace',
                name: 'workspace',
                width: 20,
            },
            {
                direction: 'ASC',
                label: 'Created',
                name: 'createdAt',
                width: 20,
            },
            {
                direction: 'ASC',
                label: 'Updated',
                name: 'updatedAt',
                width: 20,
            },
            {
                direction: 'ASC',
                label: 'Active',
                name: 'active',
                width: 10,
            },
            {
                direction: 'ASC',
                label: 'Workspace Admin',
                name: 'admin',
                width: 10,
            },
        ], query: graphql_1.workspaceMemberships, keys: {
            count: 'workspaceMembershipsCount',
            item: 'workspaceMemberships',
        }, singular: "workspace membership", plural: "workspace memberships" }));
};
exports.default = exports.WorkspaceMembershipsList;
//# sourceMappingURL=WorkspaceMembershipsList.js.map